module.exports = __webpack_public_path__ + "img/xmas_snow_bg01.d5ab7c26.png";